export default __webpack_public_path__ + "static/media/set.447404bb.png";